var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStack = function SvgStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.015.236a2.3 2.3 0 0 0-2.03 0L.62 3.37a1.106 1.106 0 0 0 0 1.987l6.365 3.134a2.3 2.3 0 0 0 2.03 0l6.365-3.134a1.106 1.106 0 0 0 0-1.987L9.015.236ZM.657 6.988c.101-.05.22-.05.321 0l6.007 2.958a2.3 2.3 0 0 0 2.03 0l6.007-2.958c.101-.05.22-.05.321 0l.037.018c.827.407.827 1.58 0 1.988l-6.365 3.134c-.64.314-1.39.314-2.03 0L.62 8.994a1.106 1.106 0 0 1 0-1.988l.037-.018Zm.321 3.637a.363.363 0 0 0-.321 0l-.037.018a1.106 1.106 0 0 0 0 1.987l6.365 3.134a2.3 2.3 0 0 0 2.03 0l6.365-3.134a1.106 1.106 0 0 0 0-1.988l-.037-.017a.363.363 0 0 0-.321 0l-6.007 2.957a2.3 2.3 0 0 1-2.03 0L.978 10.625Z"
  })));
};

export default SvgStack;